import { getPercentageUsed } from '~/components/CreditUsageMeter/utils';
import { useSubscriptionContext } from '~/providers/SubscriptionProvider';
import { useCreditStats } from '~/swr-hooks/workspaces/useCreditStats';
import { getGiftCreditsBalance } from '~/utils/creditUtils';

const FULL_CREDIT_USAGE_PERCENT = 100;

const CREDIT_USAGE_PERCENT_FORMATTER = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 2,
});

export type UseCreditUsagePercentResult = {
  label: string;
  percentUsed: number;
};

export const useCreditUsagePercent = (): UseCreditUsagePercentResult => {
  const { data: creditStats } = useCreditStats();
  const { data: subscription } = useSubscriptionContext();

  const giftCreditsBalance = getGiftCreditsBalance({
    pricingModel: subscription?.pricingModel,
    statsGiftCreditsBalance: creditStats?.giftCreditsBalance,
  });
  const totalAllocated = (creditStats?.allocated ?? 0) + giftCreditsBalance;
  // Gift credits count toward the ring the same way they do in the breakdown.
  const percentUsed = Math.min(
    FULL_CREDIT_USAGE_PERCENT,
    Math.max(0, getPercentageUsed(creditStats?.used.total ?? 0, totalAllocated)),
  );

  return {
    label: `${CREDIT_USAGE_PERCENT_FORMATTER.format(percentUsed)}% of credits used`,
    percentUsed,
  };
};
